/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PayerContract } from './PayerContract';
import {
    PayerContractFromJSON,
    PayerContractFromJSONTyped,
    PayerContractToJSON,
} from './PayerContract';

/**
 * 
 * @export
 * @interface CreatePayerContracts201Response
 */
export interface CreatePayerContracts201Response {
    /**
     * 
     * @type {PayerContract}
     * @memberof CreatePayerContracts201Response
     */
    data?: PayerContract;
}

/**
 * Check if a given object implements the CreatePayerContracts201Response interface.
 */
export function instanceOfCreatePayerContracts201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreatePayerContracts201ResponseFromJSON(json: any): CreatePayerContracts201Response {
    return CreatePayerContracts201ResponseFromJSONTyped(json, false);
}

export function CreatePayerContracts201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePayerContracts201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : PayerContractFromJSON(json['data']),
    };
}

export function CreatePayerContracts201ResponseToJSON(value?: CreatePayerContracts201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': PayerContractToJSON(value.data),
    };
}

